import axios from "axios";

//export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
//export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function isKycRequiredError(err) {
  const detail = err?.response?.data?.detail;
  return Boolean(detail && typeof detail === "object" && detail.error === "kyc_required");
}

export function formatMoney(amount, currencyCode = "RWF", currencies = []) {
  const cur = currencies.find((c) => c.code === currencyCode);
  const symbol = cur?.symbol || currencyCode;
  const isZeroDecimal = ["RWF", "UGX", "JPY", "KRW"].includes(currencyCode);
  const formatted = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: isZeroDecimal ? 0 : 2,
    maximumFractionDigits: isZeroDecimal ? 0 : 2,
  }).format(amount || 0);
  return `${symbol} ${formatted}`;
}

